import DelightLogo from "../../assets/images/delight-logo.png";
import "./ChildSafety.css";

const LAST_UPDATED = "31 December 2025";
const APP_NAME = "Flirtolo";
const CONTACT_EMAIL = "sanduntharakag1@gmail.com";
const SAFETY_CONTACT_NAME = "Flirtolo Safety Team";

export default function ChildSafety() {
  return (
    <div className="child-safety-page">
      <div className="child-safety-container">
        <div className="child-safety-header">
          <img
            src={DelightLogo}
            alt={`${APP_NAME} Logo`}
            className="child-safety-logo"
          />
          <h1 className="child-safety-title">
            {APP_NAME} – Child Safety Standards
          </h1>
        </div>

        <p className="meta">Last updated: {LAST_UPDATED}</p>

        <p>
          <strong>{APP_NAME}</strong> is committed to providing a safe
          environment for all users and strictly prohibits any form of Child
          Sexual Abuse and Exploitation (CSAE). This statement outlines our
          public standards and how we comply with child safety requirements.
        </p>

        <h2>1. Prohibition of CSAE</h2>
        <p>{APP_NAME} **prohibits any content, behavior, or conduct that:</p>
        <ul>
          <li>Sexually exploits, abuses, or endangers minors;</li>
          <li>Includes Child Sexual Abuse Material (CSAM) in any form;</li>
          <li>
            Promotes or normalizes interactions with minors in a sexual context.
          </li>
        </ul>
        <p>
          Any user found to be engaging in such behavior will have their account
          suspended or permanently banned, and we will cooperate with law
          enforcement as required by applicable law.
        </p>

        <h2>2. Age Restriction</h2>
        <p>
          Use of {APP_NAME} is restricted to users who are **18 years or
          older**. Accounts that appear to belong to minors are promptly
          reviewed and removed.
        </p>

        <h2>3. In-App Reporting & Feedback</h2>
        <p>
          Users may report suspicious or harmful content directly within the app
          using the “Report” feature available on user profiles and chat
          screens.
        </p>
        <p>
          Reports are reviewed promptly, and confirmed violations are removed
          and acted upon according to our enforcement procedures.
        </p>

        <h2>4. Content Moderation and Enforcement</h2>
        <p>
          We use a combination of automated tools and human review to detect and
          moderate content that violates these child safety standards. Confirmed
          child safety violations are:
        </p>
        <ul>
          <li>Immediately removed from the platform;</li>
          <li>Subject to account action (suspension/termination);</li>
          <li>Reported to appropriate authorities as required by law.</li>
        </ul>

        <h2>5. Compliance With Laws</h2>
        <p>
          {APP_NAME} complies with applicable child protection laws, including
          mandatory reporting obligations for confirmed CSAM cases to
          authorities such as the National Center for Missing & Exploited
          Children (NCMEC), or equivalent local agencies.
        </p>

        <h2>6. Child Safety Contact</h2>
        <p>
          For concerns related to child safety, suspected CSAE or CSAM, contact:
        </p>
        <ul>
          <li>
            <strong>{SAFETY_CONTACT_NAME}</strong>
          </li>
          <li>
            Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          </li>
        </ul>

        <h2>7. Updates to These Standards</h2>
        <p>
          We periodically review and update our child safety standards to ensure
          compliance with current laws and Google Play requirements.
        </p>
      </div>
    </div>
  );
}
